import { render } from "./SubProjectEditWidget.vue?vue&type=template&id=45755f0a&ts=true"
import script from "./SubProjectEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./SubProjectEditWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__